// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .new-podium-content{
    margin-top: calc(var(--space));
} */

.new-podium-content__title{
    color: var(--primary-very-dark-color);
    padding-bottom: var(--space-and-half);
}

.new-podium-content__position_content{
    background-color: var(--white-color);
    padding: 24px;
    border-radius: var(--space-half);
}

.new-podium-content__position__champion{
    background-color: var(--white-color);
    width: 100%;
    border-radius: var(--space-half);
    display: flex;
}

.new-podium-content__position__champion__text{
    margin-top: 10px;
    margin-right: calc(var(--space-x3)*1.6);
    width: 100%;
}

.baloa-subtitle-2.new-podium-content__position__champion__text__title{
    color: var(--primary-very-dark-color);
    white-space: nowrap;
}

.new-podium-content__position__champion__text__name.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    padding-bottom: 5px;
}

.new-podium-content__position__champion__text__username.baloa-table-column{
    color: var(--basic-gray-color);
    font-size: var(--space);
}

.new-podium-content__position__image__content {
    display: flex;
    align-items: center;
    padding-right: 16px;
}

.new-podium-content__position__image__content .icon-ball{
    font-size: 42px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    color: var(--white-color);
}

.new-podium-content__position__champion__subtitle{
    padding: 20px;
    text-align: center;
}

.new-podium-content__position__image__content img.has_img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.new-podium-content__recognition{
    display: flex;
    justify-content: center;
    flex-direction:row;
    grid-gap: var(--space-and-half);
    gap: var(--space-and-half);
}

.new-podium-content-title{
    display: flex;
    width: 100%;
    margin-bottom: 16px;
    justify-content: space-between;
}

.new-podium-content__recognition__box{
    background-color: var(--white-color);
    height: 166px;
    border-radius: var(--space-half);
    margin-top: var(--space-x2);
    padding: 24px;
    flex-wrap: wrap;
}

.new-podium-content__recognition__box.left{
    width: 50%;
}

.new-podium-content__recognition__box.right{
    width: 50%;
}

.new-podium-content__recognition__box__image__content {
    display: flex;
    align-items: center;
    padding-right: 16px;
}

.new-podium-content__recognition__box__image__content .icon-ball{
    font-size: 42px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    color: var(--white-color);
}

.new-podium-content__recognition__box__image__content img {
    width: 50px;
    height: 50px;
    border-radius: 50%;    
}

.new-podium-content__recognition__box__text{
    text-align: center;
    cursor: pointer;
}

.new-podium-content__recognition__box__text .baloa-subtitle-2{
    color: var(--primary-very-dark-color);
}

.new-podium-content__recognition__box__text__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-half);
}

.new-podium-content__recognition__box__team{
    display: flex;
    margin-top: var(--space);
    align-items: center;
    flex-basis: 100%;
    align-self: flex-start;
    cursor: pointer;
    justify-content: center;
}

.new-podium-content__recognition__box__team__image{
    width: 24px;
    height: 24px;
    margin-right: var(--space-half);
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-podium-content__recognition__box__team__image .icon-ball{
    font-size: 18px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 3px;
    color: var(--white-color);
}

.new-podium-content__recognition__box__team__image img{
    max-width: var(--space-and-half);
    max-height: var(--space-and-half);
    border-radius: 50%;
}

.new-podium-content__recognition__box__team.margin{
    margin-left: var(--space-half);
}

.new-podium-content__position {
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .new-podium-content__recognition {
        flex-direction: column;
        align-items: center;
    }
    .new-podium-content__recognition__box__image {
        width: 60px;
        height: 60px;
        margin-top: -32px;
        position: unset;
    }
    .new-podium-content__recognition__box__image__content .icon-ball {
        font-size: 20px;
        padding: 4px;
    }
    .new-podium-content__recognition__box__image__content img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }    
    .new-podium-content__recognition__box.left,
    .new-podium-content__recognition__box.right {
        width: 100%;
    }

    .new-podium-content__recognition__box.left .new-podium-content__position,
    .new-podium-content__recognition__box.right .new-podium-content__position{
        margin-top: 0;
    }
    
    .new-podium-content__recognition__box__team {        
        margin-top: 4px;
        flex-basis: unset;
        align-self: center;
        margin-bottom: var(--space);
    }
    .new-podium-content__recognition__box__text{
        margin-top: var(--space);
    }
    .new-podium-content__recognition__box {
        margin-top: var(--space);
        padding: var(--space);
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: unset;
        height: unset;
    }
    .new-podium-content__recognition__box__team__image img{
        max-width: var(--space-x2);
        max-height: var(--space-x2);
        border-radius: 50%;
    }
    .new-podium-content__recognition__box__team .baloa-caption {
        font-size: calc( var(--space) + 1px );
    }    
/* }
@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ */
    .new-podium-content {
        display: flex;
        flex-direction: column;
        margin: 0 var(--space);

    }

    .new-podium-content__position {
        width: 100%;
        margin-top: var(--space);
    }

    .new-podium-content__title{
        padding: 0;
    }

    .league-tournament-report__podium__container {        
        padding-top: 50px;        
    }    

    .new-podium-content__position__image.champion__image {
        width: 100px;
        height: 100px;
        margin-top: -54px;
    }

    .new-podium-content__position__image.subcampeon__image {
        width: 90px;
        height: 90px;
        margin-top: -45px;
    }
    .third__image .new-podium-content__position__image__content .icon-ball {
        font-size: 57px;
    }
    .new-podium-content__position__image.third__image {
        width: 66px;
        height: 66px;
        margin-top: -32px;
    }
    .new-podium-content__position__image.third__image img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    .subcampeon__image .new-podium-content__position__image__content .icon-ball {
        font-size: 78px;
    }

    .new-podium-content__position__image.champion__image span {
        font-size: 90px;
        font-weight: var(--font-bold);
        border-radius: 50%;
        padding: 5px;
        color: var(--white-color);
    }
    .new-podium-content__position__champion.color{
        width: 23rem;
    }
    .new-podium-content__position__champion {
        align-items: center;
    }
    .new-podium-content__position__image.subcampeon__image img {
        width: 90px;
        height: 90px;
        border-radius: 50%;
    }

    .new-podium-content__position__champion__text__name.baloa-subtitle-2 {

        padding-bottom: 0;
    }
    
    .new-podium-content__recognition{
        gap: 0;        
    }

    .new-podium-content__position_content{
        padding: var(--space);
    }

    .new-podium-content__position__image__content{
        padding-right: 10px;
    }

    .new-podium-content__position__image__content .icon-ball {
        font-size: 20px;
        padding: 4px;
    }

    .new-podium-content__position__image__content img.has_img{
        width: 28px;
        height: 28px;
    }

    .new-podium-content__position__champion__text {
        margin-top: 0;
        margin-right: 0;
    }

    .new-podium-content__position__champion__subtitle {
        padding: 0 10px 0 0;
        text-align: center;
    }

    .baloa-subtitle-2.new-podium-content__position__champion__text__title {
        color: var(--basic-gray-color);
    }
    .new-podium-content__recognition__box__image__content{
        padding-right: var(--space);
    }
    .new-podium-content-title{
        margin-bottom: var(--space);
    }
    .new-podium-content__recognition__box__text__title.baloa-subtitle-2{
        margin-bottom: 0;
    }

    .new-podium-content__recognition__box__text__title.baloa-subtitle-2:first-child {
        color: var(--primary-very-dark-color);
    }

    .new-podium-content__recognition__box__text__title.baloa-subtitle-2:nth-child(2) {
        color: var(--basic-gray-color);
    }

    .new-podium-content__recognition__box .baloa-subtitle-2.new-podium-content__position__champion__text__title{
        color: var(--primary-very-dark-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-new-podium/TournamentNewPodiumComponent.styles.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,gCAAgC;IAChC,2BAA2B;IAC3B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;;QAEI,WAAW;IACf;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,qBAAqB;QACrB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,kBAAkB;IACtB;IACA;QACI,qCAAqC;IACzC;AACJ;qEACqE,EAAE;;QAE/D,aAAa;QACb,sBAAsB;QACtB,sBAAsB;;IAE1B;;IAEA;QACI,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;QAClB,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;IAClC;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":["/* .new-podium-content{\n    margin-top: calc(var(--space));\n} */\n\n.new-podium-content__title{\n    color: var(--primary-very-dark-color);\n    padding-bottom: var(--space-and-half);\n}\n\n.new-podium-content__position_content{\n    background-color: var(--white-color);\n    padding: 24px;\n    border-radius: var(--space-half);\n}\n\n.new-podium-content__position__champion{\n    background-color: var(--white-color);\n    width: 100%;\n    border-radius: var(--space-half);\n    display: flex;\n}\n\n.new-podium-content__position__champion__text{\n    margin-top: 10px;\n    margin-right: calc(var(--space-x3)*1.6);\n    width: 100%;\n}\n\n.baloa-subtitle-2.new-podium-content__position__champion__text__title{\n    color: var(--primary-very-dark-color);\n    white-space: nowrap;\n}\n\n.new-podium-content__position__champion__text__name.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    padding-bottom: 5px;\n}\n\n.new-podium-content__position__champion__text__username.baloa-table-column{\n    color: var(--basic-gray-color);\n    font-size: var(--space);\n}\n\n.new-podium-content__position__image__content {\n    display: flex;\n    align-items: center;\n    padding-right: 16px;\n}\n\n.new-podium-content__position__image__content .icon-ball{\n    font-size: 42px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    color: var(--white-color);\n}\n\n.new-podium-content__position__champion__subtitle{\n    padding: 20px;\n    text-align: center;\n}\n\n.new-podium-content__position__image__content img.has_img{\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n}\n\n.new-podium-content__recognition{\n    display: flex;\n    justify-content: center;\n    flex-direction:row;\n    grid-gap: var(--space-and-half);\n    gap: var(--space-and-half);\n}\n\n.new-podium-content-title{\n    display: flex;\n    width: 100%;\n    margin-bottom: 16px;\n    justify-content: space-between;\n}\n\n.new-podium-content__recognition__box{\n    background-color: var(--white-color);\n    height: 166px;\n    border-radius: var(--space-half);\n    margin-top: var(--space-x2);\n    padding: 24px;\n    flex-wrap: wrap;\n}\n\n.new-podium-content__recognition__box.left{\n    width: 50%;\n}\n\n.new-podium-content__recognition__box.right{\n    width: 50%;\n}\n\n.new-podium-content__recognition__box__image__content {\n    display: flex;\n    align-items: center;\n    padding-right: 16px;\n}\n\n.new-podium-content__recognition__box__image__content .icon-ball{\n    font-size: 42px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    color: var(--white-color);\n}\n\n.new-podium-content__recognition__box__image__content img {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;    \n}\n\n.new-podium-content__recognition__box__text{\n    text-align: center;\n    cursor: pointer;\n}\n\n.new-podium-content__recognition__box__text .baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n}\n\n.new-podium-content__recognition__box__text__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.new-podium-content__recognition__box__team{\n    display: flex;\n    margin-top: var(--space);\n    align-items: center;\n    flex-basis: 100%;\n    align-self: flex-start;\n    cursor: pointer;\n    justify-content: center;\n}\n\n.new-podium-content__recognition__box__team__image{\n    width: 24px;\n    height: 24px;\n    margin-right: var(--space-half);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.new-podium-content__recognition__box__team__image .icon-ball{\n    font-size: 18px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 3px;\n    color: var(--white-color);\n}\n\n.new-podium-content__recognition__box__team__image img{\n    max-width: var(--space-and-half);\n    max-height: var(--space-and-half);\n    border-radius: 50%;\n}\n\n.new-podium-content__recognition__box__team.margin{\n    margin-left: var(--space-half);\n}\n\n.new-podium-content__position {\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .new-podium-content__recognition {\n        flex-direction: column;\n        align-items: center;\n    }\n    .new-podium-content__recognition__box__image {\n        width: 60px;\n        height: 60px;\n        margin-top: -32px;\n        position: unset;\n    }\n    .new-podium-content__recognition__box__image__content .icon-ball {\n        font-size: 20px;\n        padding: 4px;\n    }\n    .new-podium-content__recognition__box__image__content img {\n        width: 100%;\n        height: 100%;\n        border-radius: 50%;\n    }    \n    .new-podium-content__recognition__box.left,\n    .new-podium-content__recognition__box.right {\n        width: 100%;\n    }\n\n    .new-podium-content__recognition__box.left .new-podium-content__position,\n    .new-podium-content__recognition__box.right .new-podium-content__position{\n        margin-top: 0;\n    }\n    \n    .new-podium-content__recognition__box__team {        \n        margin-top: 4px;\n        flex-basis: unset;\n        align-self: center;\n        margin-bottom: var(--space);\n    }\n    .new-podium-content__recognition__box__text{\n        margin-top: var(--space);\n    }\n    .new-podium-content__recognition__box {\n        margin-top: var(--space);\n        padding: var(--space);\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        flex-wrap: unset;\n        height: unset;\n    }\n    .new-podium-content__recognition__box__team__image img{\n        max-width: var(--space-x2);\n        max-height: var(--space-x2);\n        border-radius: 50%;\n    }\n    .new-podium-content__recognition__box__team .baloa-caption {\n        font-size: calc( var(--space) + 1px );\n    }    \n/* }\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ */\n    .new-podium-content {\n        display: flex;\n        flex-direction: column;\n        margin: 0 var(--space);\n\n    }\n\n    .new-podium-content__position {\n        width: 100%;\n        margin-top: var(--space);\n    }\n\n    .new-podium-content__title{\n        padding: 0;\n    }\n\n    .league-tournament-report__podium__container {        \n        padding-top: 50px;        \n    }    \n\n    .new-podium-content__position__image.champion__image {\n        width: 100px;\n        height: 100px;\n        margin-top: -54px;\n    }\n\n    .new-podium-content__position__image.subcampeon__image {\n        width: 90px;\n        height: 90px;\n        margin-top: -45px;\n    }\n    .third__image .new-podium-content__position__image__content .icon-ball {\n        font-size: 57px;\n    }\n    .new-podium-content__position__image.third__image {\n        width: 66px;\n        height: 66px;\n        margin-top: -32px;\n    }\n    .new-podium-content__position__image.third__image img {\n        width: 100%;\n        height: 100%;\n        border-radius: 50%;\n    }\n\n    .subcampeon__image .new-podium-content__position__image__content .icon-ball {\n        font-size: 78px;\n    }\n\n    .new-podium-content__position__image.champion__image span {\n        font-size: 90px;\n        font-weight: var(--font-bold);\n        border-radius: 50%;\n        padding: 5px;\n        color: var(--white-color);\n    }\n    .new-podium-content__position__champion.color{\n        width: 23rem;\n    }\n    .new-podium-content__position__champion {\n        align-items: center;\n    }\n    .new-podium-content__position__image.subcampeon__image img {\n        width: 90px;\n        height: 90px;\n        border-radius: 50%;\n    }\n\n    .new-podium-content__position__champion__text__name.baloa-subtitle-2 {\n\n        padding-bottom: 0;\n    }\n    \n    .new-podium-content__recognition{\n        gap: 0;        \n    }\n\n    .new-podium-content__position_content{\n        padding: var(--space);\n    }\n\n    .new-podium-content__position__image__content{\n        padding-right: 10px;\n    }\n\n    .new-podium-content__position__image__content .icon-ball {\n        font-size: 20px;\n        padding: 4px;\n    }\n\n    .new-podium-content__position__image__content img.has_img{\n        width: 28px;\n        height: 28px;\n    }\n\n    .new-podium-content__position__champion__text {\n        margin-top: 0;\n        margin-right: 0;\n    }\n\n    .new-podium-content__position__champion__subtitle {\n        padding: 0 10px 0 0;\n        text-align: center;\n    }\n\n    .baloa-subtitle-2.new-podium-content__position__champion__text__title {\n        color: var(--basic-gray-color);\n    }\n    .new-podium-content__recognition__box__image__content{\n        padding-right: var(--space);\n    }\n    .new-podium-content-title{\n        margin-bottom: var(--space);\n    }\n    .new-podium-content__recognition__box__text__title.baloa-subtitle-2{\n        margin-bottom: 0;\n    }\n\n    .new-podium-content__recognition__box__text__title.baloa-subtitle-2:first-child {\n        color: var(--primary-very-dark-color);\n    }\n\n    .new-podium-content__recognition__box__text__title.baloa-subtitle-2:nth-child(2) {\n        color: var(--basic-gray-color);\n    }\n\n    .new-podium-content__recognition__box .baloa-subtitle-2.new-podium-content__position__champion__text__title{\n        color: var(--primary-very-dark-color);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
